import { IApplicantFormService } from "../../service/form/ApplicantFormService";

export default class GetAdditionalEvaluationResultInteractor {
  private applicantFormService: IApplicantFormService;

  constructor(applicantFormService) {
    this.applicantFormService = applicantFormService;
  }

  async execute(reportingPeriodApplicantId: number) {
    return this.applicantFormService.getAdditionalEvaluationResult(
      reportingPeriodApplicantId
    );
  }
}
